module.exports = __webpack_public_path__ + "img/login_cover.496f41f2.jpg";